import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from '../constants';
import agentKbRootDoc from './agentKbRootDoc';

const converter = {
  toFirestore(item: AgentKb.Revision): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): AgentKb.Revision {
    return {
      ...(snapshot.data(options) as AgentKb.Revision),
      id: snapshot.id,
    };
  },
};

// Revision bodies: agentKb/main/revisions/{artefactId}__{rev}. Immutable once
// written, so the client caches them by doc id and never re-reads one.
const getAgentKbRevisionsRef = ({
  scope,
  accountId,
  db,
}: {
  scope: AgentKb.ScopeName;
  accountId?: string;
  db?: firebase.firestore.Firestore;
}) =>
  agentKbRootDoc({ scope, accountId, db })
    .collection(STORE_CONSTANTS.AGENT_KB_REVISIONS_COLLECTION)
    .withConverter(converter);

export default getAgentKbRevisionsRef;
